var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5908 4.84544C25.2809 4.53563 24.8607 4.36157 24.4226 4.36155L8.8928 4.36066C7.98031 4.36061 7.24056 5.1003 7.24054 6.01279L7.23983 32.3678C7.2398 33.2803 7.97951 34.02 8.89199 34.02L29.4919 34.0203C30.4044 34.0203 31.1441 33.2806 31.1441 32.3682L31.1453 11.0843C31.1453 10.646 30.9712 10.2258 30.6614 9.9159L25.5908 4.84544Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.1072 6.87577C25.107 8.10972 25.107 8.72669 25.3471 9.19798C25.5583 9.61255 25.8953 9.94959 26.3099 10.1608C26.7812 10.4009 27.3981 10.4009 28.6321 10.4008L31.1458 10.4006L25.1074 4.3623L25.1072 6.87577Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.e95a0241e3709fafc74e188e3c81347f.svg";
export { ForwardRef as ReactComponent };